<script>
  /**
   * NOTE: You must add a `name` attribute for each input/select/textarea element for the isFormDirty to work.
   */

  import { beforeNavigate } from '$app/navigation';
  import { compareFormData } from '$lib/utils/compareFormData';

  let {
    showConfirmationIfDirty = false,
    isFormDirty = $bindable(false),
    onsubmit = undefined,
    onformDirty = undefined,
    children = undefined,
    ...rest
  } = $props();

  let formElement = $state();
  let controlCount = 0;
  let initialFormData;

  const onChange = () => {
    if (!initialFormData) return;
    isFormDirty = !compareFormData(initialFormData, new FormData(formElement));
  };

  const syncBaseline = () => {
    if (!formElement) return;
    const count = formElement.querySelectorAll(
      'input, select, textarea',
    ).length;
    if (count !== controlCount) {
      controlCount = count;
      initialFormData = new FormData(formElement);
    }
  };

  $effect(() => {
    if (!formElement) return;
    syncBaseline();
    const observer = new MutationObserver(syncBaseline);
    observer.observe(formElement, { childList: true, subtree: true });
    return () => observer.disconnect();
  });

  $effect(() => {
    onformDirty?.(isFormDirty);
  });

  beforeNavigate((navigation) => {
    if (
      showConfirmationIfDirty &&
      isFormDirty &&
      !window.confirm('Du har osparade ändringar. Vill lämna sidan?')
    ) {
      navigation.cancel();
    }
  });

  function handleSubmit(e) {
    e.preventDefault();
    onsubmit?.(new FormData(formElement));
    isFormDirty = false;
  }
</script>

<!--
  {...rest} comes first so a caller-supplied attribute can never clobber the
  handlers below. Previously on:submit was a directive and was immune to the
  spread; onsubmit is a plain attribute and would not be.

  change/input are delegated on the form rather than bound per control: both
  bubble, so this covers controls mounted later for free and removes the
  attach/detach bookkeeping the old afterUpdate() block did.
-->
<form
  {...rest}
  bind:this={formElement}
  onsubmit={handleSubmit}
  onchange={onChange}
  oninput={onChange}
>
  {@render children?.()}
</form>
